import React from "react"
import { Box, Typography, List, ListItem } from "@mui/joy"
import { PersonAvatar } from "../Snippet"

const InfoHeaderCampaignLeadOperator = ({ item }) => {
	return (
		<Box
			className="info-header info-header-person"
			sx={{
				display: 'flex',
				alignItems: 'center',
				borderRadius: 'lg',
				bgcolor: '#FFFFFF',
				p: 3,
				gap: 2
			}}
		>
			<PersonAvatar 
				firstname={item?.lead?.firstname}
				lastname={item?.lead?.lastname}
				url={item?.lead?.picture?.url}
				item={item?.lead}
			/>

			<Box sx={{ flex: 1 }}>
				<Typography
					level="h1"
					sx={{
						fontSize: '1.5rem',
						fontWeight: 700,
						color: "var(--customer-800)",
						mb: 1
					}}
				>
					{item?.lead?.firstname} {item?.lead?.lastname}
				</Typography>

				<List
					orientation="horizontal"
					sx={{
						gap: 3,
						m: 0,
						p: 0,
						alignItems: 'center'
					}}
				>
					{item?.lead?.email && (
						<ListItem sx={{ p: 0 }}>
							<Typography
								level="body-md"
								sx={{
									color: "var(--neutral-600)",
									display: 'flex',
									alignItems: 'center',
									gap: 0.5
								}}
							>
								📧 {item?.lead?.email}
							</Typography>
						</ListItem>
					)}

					{item?.lead?.mobile && (
						<ListItem sx={{ p: 0 }}>
							<Typography
								level="body-md"
								sx={{
									color: "var(--neutral-600)",
									display: 'flex',
									alignItems: 'center',
									gap: 0.5
								}}
							>
								📞 {item?.lead?.mobile}
							</Typography>
						</ListItem>
					)}

					{(item?.lead?.resStreet || item?.lead?.resCity) && (
						<ListItem sx={{ p: 0 }}>
							<Typography
								level="body-md"
								sx={{
									color: "var(--neutral-600)",
									display: 'flex',
									alignItems: 'center',
									gap: 0.5
								}}
							>
								📍 {item?.lead?.resStreet}, {item?.lead?.resZip} {item?.lead?.resCity} ({item?.lead?.resDistrict})
							</Typography>
						</ListItem>
					)}
				</List>
			</Box>
		</Box>
	)
}

export default InfoHeaderCampaignLeadOperator